// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__9wIoS","loader_flex":"styles_loader_flex__RYDOT"};